import { Component, OnInit } from '@angular/core';

import { IToast, ToasterService } from '../../services/toaster.service';

@Component({
  selector: 'dc-toaster-container',
  templateUrl: './toaster-container.component.html',
  styleUrls: ['./toaster-container.component.less'],
})
export class ToasterContainerComponent implements OnInit {
  toasts: IToast[] = [];

  constructor(private ToasterService: ToasterService) {}

  ngOnInit() {
    this.ToasterService.toast$.subscribe((toast) => {
      this.toasts = [<IToast>toast, ...this.toasts];
      setTimeout(() => this.toasts.pop(), (<IToast>toast).delay);
    });
  }

  remove(index: number) {
    this.toasts = this.toasts.filter((_v, i) => i !== index);
  }
}
